import usePageMeta from "utils/usePageMeta";
import Navbar from "./sections/Navbar";
import Hero from "./sections/Hero";
import Features from "./sections/Features";
import HowItWorks from "./sections/HowItWorks";
import ForWho from "./sections/ForWho";
import CTA from "./sections/CTA";
import ContactForm from "./sections/ContactForm";

function WorkforceApp() {
  usePageMeta({
    title: "Spechs Workforce | Staff Tracking & Payroll App for Ireland",
    description:
      "Track attendance, manage schedules, and automate payroll with GPS precision. The Spechs Workforce app is built for companies managing field workers across multiple sites in Ireland.",
    canonical: "https://www.spechs.ie/workforce/",
  });

  return (
    <>
      <Navbar />
      <Hero />
      <Features />
      <HowItWorks />
      <ForWho />
      <CTA />
      <ContactForm />
    </>
  );
}

export default WorkforceApp;
